import React from 'react';
import { useDarkMode } from '../../stores/themeStore';

interface XTNDFullLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export function XTNDFullLogo({ className = '', size = 'md' }: XTNDFullLogoProps) {
  const { isDark } = useDarkMode();
  
  const sizeClasses = {
    sm: 'h-8 w-auto',
    md: 'h-10 w-auto',
    lg: 'h-16 w-auto',
    xl: 'h-20 w-auto',
  };

  // Use dark mode logo when in dark mode
  const logoSrc = isDark ? '/xtnd-dark.png' : '/xtnd.png';

  return (
    <img src={logoSrc} alt="XTND Juniper Logo" className={`${sizeClasses[size]} ${className}`} />
  );
}

export default XTNDFullLogo;
